<mat-sidenav-container class="sidenav-container">
    <mat-sidenav #sidenav mode="over" position="start" hasBackdrop="true">
        <div class="content-close">
            <button mat-icon-button (click)="closeSidenav()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <hr>
        <div class="sidenav-content">
            <a href="/" (click)="closeSidenav()" class="side-link">
                <mat-icon>home</mat-icon>
                <span>Inicio</span>
            </a>
            <a href="/quienes-somos" (click)="closeSidenav()" class="side-link">
                <mat-icon>info</mat-icon>
                <span>Quiénes Somos</span>
            </a>
            <a href="/terms-conditions" (click)="closeSidenav()" class="side-link">
                <mat-icon>description</mat-icon>
                <span>Términos y Condiciones</span>
            </a>
            <a href="/privacy" (click)="closeSidenav()" class="side-link">
                <mat-icon>security</mat-icon>
                <span>Política de Privacidad</span>
            </a>

            <div class="side-download-section">
                <span class="side-download-title">Descarga la App Workbi</span>
                <a href="https://play.google.com/store/apps/details?id=co.workbi&pcampaignid=web_share" target="_blank"
                    rel="noopener noreferrer" (click)="closeSidenav()" class="store-badge-btn android">
                    <img src="assets/images/google-play.svg" alt="Google Play">
                    <div class="btn-text">
                        <small>Disponible en</small>
                        <strong>Google Play</strong>
                    </div>
                </a>
                <a href="https://apps.apple.com/co/app/workbi/id6756087985?l=en-GB" target="_blank"
                    rel="noopener noreferrer" (click)="closeSidenav()" class="store-badge-btn ios">
                    <img src="assets/images/download-ios.svg" alt="App Store">
                    <div class="btn-text">
                        <small>Consíguelo en el</small>
                        <strong>App Store</strong>
                    </div>
                </a>
            </div>
        </div>
    </mat-sidenav>
</mat-sidenav-container>